import React from 'react';

import { SuggestionProps } from '@tiptap/suggestion';
import useSearch from 'app/components/CommonStyled/Search/hooks/useSearch';
import { Spinner } from 'app/components/shared/icons';
import useBehavioral, { BEHAVIORALS } from 'hooks/useBehavioral';
import useDebounce from 'hooks/useDebounce';
import { oldModelsToNew, oldModelsToNewSelectedCriteriaLabel } from 'utils/constants';

import {
  RichTextEditorCustomMentionListHeader,
  RichTextEditorCustomMentionListHeaderText,
  RichTextEditorCustomMentionListItemContainer,
  RichTextEditorCustomMentionListItemContainerText,
  RichTextEditorCustomMentionListLoadingContainer,
  RichTextEditorCustomMentionListWrapper,
  RichTextEditorCustomMentionListItemType,
} from './styled';

export const RichTextEditorCustomMentionList = ({
  items,
  command,
  query,
}: SuggestionProps<any, any>) => {
  const debouncedValue = useDebounce(query);
  const messageMentionSelected = useBehavioral(BEHAVIORALS.MESSAGE_MENTION_SELECTED);
  const { data, isLoading } = useSearch(debouncedValue, { enabled: !!debouncedValue });

  const handleMentionSelected = (e, item) => {
    e.preventDefault();
    messageMentionSelected({
      related_object_uuid: item.uuid,
      related_object_type: item.datatype,
      action_details: `Mentioned ${item.name}`,
    });
    command({
      uuid: item.uuid,
      'data-type': oldModelsToNew[item.datatype],
      title: item.name,
      'data-slug': item.slug,
      label: item.name,
      class: 'mention',
    });
  };

  return (
    <RichTextEditorCustomMentionListWrapper data-id="rich-text-editor-custom-mention-list">
      <RichTextEditorCustomMentionListHeader>
        <RichTextEditorCustomMentionListHeaderText>
          Type to search
        </RichTextEditorCustomMentionListHeaderText>
      </RichTextEditorCustomMentionListHeader>
      {isLoading ? (
        <RichTextEditorCustomMentionListLoadingContainer>
          <Spinner fill="var(--color-text)" />
        </RichTextEditorCustomMentionListLoadingContainer>
      ) : null}
      {data?.map((item, index) => (
        <RichTextEditorCustomMentionListItemContainer
          key={item.uuid}
          data-id={`rich-text-editor-custom-mention-list-item`}
          data-rte-custom-mention-list-item
          onMouseDown={(e) => handleMentionSelected(e, item)}
        >
          <RichTextEditorCustomMentionListItemContainerText data-rte-custom-mention-list-item>
            {item.name}
          </RichTextEditorCustomMentionListItemContainerText>
          {item.info ? (
            <RichTextEditorCustomMentionListItemType>
              {item.info}
            </RichTextEditorCustomMentionListItemType>
          ) : null}
        </RichTextEditorCustomMentionListItemContainer>
      ))}
    </RichTextEditorCustomMentionListWrapper>
  );
};
